export default __webpack_public_path__ + "static/image1-df7ea33c6c959448647cc2b8f887da2a.jpg";